import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../components/base-modal/base-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { urlSyntaxValidator } from '@app/shared/form-validations';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  standalone: true,
  selector: 'app-add-incident-via-url-modal',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatRadioModule,
    FormsModule,
    BaseModalComponent,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './add-incident-via-url-modal.component.html',
  styleUrl: './add-incident-via-url-modal.component.scss',
})
export class AddIncidentViaUrlModalComponent {
  protected formGroup: FormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<AddIncidentViaUrlModalComponent>,
    private readonly formBuilder: FormBuilder,
  ) {
    this.dialogRef.disableClose = true;

    this.formGroup = this.formBuilder.group({
      url: [null, [Validators.required, urlSyntaxValidator]],
    });
  }

  protected onAddIncident(): void {
    this.dialogRef.close(this.formGroup.value.url);
  }

  protected onCancel(): void {
    this.dialogRef.close(null);
  }
}
